// Shared API error classes for the admin portal.
//
// The admin-svc client (adminApi.ts) and the auth gate (AdminAuthGate.tsx)
// throw/inspect these so React Query's global handler can tell the three cases
// apart. Kept in their own module (rather than inside adminApi.ts) so both the
// client and the gate can import them without a cycle.
//
// 401 vs 403 IS A REAL DISTINCTION — conflating them was a bug (2026-07-20):
// both mapped to ApiAuthError, and the global handler logs out on that. So a
// staffer whose role simply lacked one page's permission got their SESSION
// DESTROYED and was bounced to the login screen, which read as "I can't sign
// in". A denial must never end a session.

/** Generic API failure (a non-2xx that isn't an auth error). */
export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/** 401 — the staff token is missing, wrong, or expired. The session is dead,
 *  so the only recovery is signing in again. */
export class ApiAuthError extends ApiError {
  constructor(status: number, message = 'unauthorized') {
    super(status, message);
    this.name = 'ApiAuthError';
  }
}

/** 403 — the session is VALID but this role isn't allowed here. Handled in the
 *  page/route, never by logging out. */
export class ApiForbiddenError extends ApiError {
  constructor(message = 'forbidden') {
    super(403, message);
    this.name = 'ApiForbiddenError';
  }
}
